<template>
  <div class="error" v-if="hasError">
    <CAlert show color="danger">
      <strong>A problem occured: </strong>
      {{ hasError }}
      <CButton v-if="errorAction" color="danger" class="ml-2" @click="doAction">Go now</CButton>
    </CAlert>
  </div>
</template>

<script>
/**
 * This can be used with `dispatch('throwError', error)` or
 * `dispatch('throwError', { hasError: errorMessage,
 *   errorAction: error.response.data.action })`.
 * Should be able to clear with `dispatch('closeError')`.
 */
import { mapState } from 'vuex'
export default {
  name: 'Error',
  computed: mapState({
    hasError(state) {
      if (state.error && !state.error.hasError) {
        return state.error
      } else if (state.error.hasError) {
        return state.error.hasError
      }
      return false
    },
    errorAction: state => state.error.errorAction,
  }),
  methods: {
    doAction() {
      this.$router.push({ path: `/${this.errorAction.link}/${this.errorAction.id}` })
    },
  },
}
</script>

<style scoped>
.error {
  width: 100%;
  padding-right: 30px;
  padding-left: 30px;
}
.error > div {
  margin: 12px 0;
}
</style>
